const getConfig = require('next/config').default

const { getConfigFor } = require('./configService')
const { SPLIT_FEATURES } = require('./constants')

const JWC_LEGACY_PATH = '/loyalty/programmes/jwc'
const JWC_MEMBERHUB_PATH = '/memberhub'
const JWC_LINK_LABEL = 'Just Wine Club'

const getMemberhubBaseUrl = () => {
  const {
    publicRuntimeConfig: {
      DOMAIN_URL = process.env.DOMAIN_URL,
      DYNAMIC_DOMAIN = process.env.DYNAMIC_DOMAIN,
      ENVIRONMENT = process.env.ENVIRONMENT,
    } = {},
  } = getConfig()

  const domainUrl = (DOMAIN_URL || '').replace(/\/$/, '')
  const dynamicDomain = (DYNAMIC_DOMAIN || '').replace(/\/$/, '')
  const isPreviewMode =
    ENVIRONMENT === 'UATPREVIEW' || ENVIRONMENT === 'PRODPREVIEW'
  const isLocalhost = /localhost|127\.0\.0\.1/.test(domainUrl)

  // Memberhub is hosted outside this app; local/preview dev must target UAT via DYNAMIC_DOMAIN.
  if ((isPreviewMode || isLocalhost) && dynamicDomain) {
    return dynamicDomain
  }

  return domainUrl
}

const getJwcMemberhubUrl = (query = '') => {
  return `${getMemberhubBaseUrl()}${JWC_MEMBERHUB_PATH}${query}`
}

const getJwcPath = () => {
  const { isEnabled: isJwcMemberhubEnabled } = getConfigFor(
    SPLIT_FEATURES.FE_JWC_MEMBERHUB
  )

  return isJwcMemberhubEnabled ? JWC_MEMBERHUB_PATH : JWC_LEGACY_PATH
}

const getJwcUrl = () => {
  const { isEnabled: isJwcMemberhubEnabled } = getConfigFor(
    SPLIT_FEATURES.FE_JWC_MEMBERHUB
  )

  if (!isJwcMemberhubEnabled) {
    return JWC_LEGACY_PATH
  }

  return getJwcMemberhubUrl()
}

const resolveJwcLinkUrl = (url, label) => {
  if (label === JWC_LINK_LABEL) {
    return getJwcUrl()
  }

  return url
}

module.exports = {
  JWC_LEGACY_PATH,
  JWC_MEMBERHUB_PATH,
  JWC_LINK_LABEL,
  getJwcMemberhubUrl,
  getJwcPath,
  getJwcUrl,
  resolveJwcLinkUrl,
}
